
export enum ProcessTypeEnum {
  Add, Edit, Delete
}
